import * as React from 'react';
import { Link } from 'react-router-dom';
import { ICategories } from '../../types/nav';
import { IUser } from '../../types/user';
import { removeExtraSlashesFromUrl, removeSlashes } from '../../../app/utils';

import s from './category.css';

interface IProps {
  currentUser: IUser;
  categories: ICategories | null;
  pathname: string;
  routePath: string;
  activeNavItem: string;
  onNavigationClick(): void;
}

export const Category = (props: IProps) => {
  const  {
    currentUser,
    categories,
    pathname,
    routePath,
    activeNavItem,
    onNavigationClick,
  } = props;

  if (!categories) {
    return null;
  }

  const isActive = (param: string) => {
    const pathnameWithoutSlashes = removeSlashes(routePath);
    const itemPathWithoutSlashed = removeSlashes(pathname);

    const value = typeof categories[param] === 'object'
      ? categories[param].value
      : categories[param];

    return value === activeNavItem &&
      (pathnameWithoutSlashes.startsWith(itemPathWithoutSlashed) ||
      (routePath.includes('/add-blog') && itemPathWithoutSlashed === 'blogs') ||
      (routePath.includes('/moi-blog') && itemPathWithoutSlashed === 'blogs') ||
      (routePath.includes('/add-vopros') && itemPathWithoutSlashed === 'forum-rieltorov'));
  };

  return (
    <ul className={`${s['category']} ${s['category-mobile']}`}>
      { Object.keys(categories).map((param, i) => {
        if (((currentUser.blogsCount || 0) < 1) && (param === 'myBlog')) {
          return null;
        }
        if (((currentUser.userId === -1) || currentUser.isBlock) && (param === 'addBlog')) {
          return null;
        }
        if (currentUser.isBlock && (param === 'addVopros')) {
          return null;
        }

        if (typeof categories[param] === 'object') {
          return (
            <li
              key={`${categories[param].value}-${i}`}
              className={`${s['category__item']} ${isActive(param) ? s['category__item_active'] : ''}`}
              onClick={onNavigationClick}
            >
              <div className={s['category__item_wrapper']}>
                <Link
                  to={{ pathname: removeExtraSlashesFromUrl(`${categories[param].pathname}/`) }}
                  className={s['category__item_link']}
                >
                  { categories[param].icon && <span className={s[categories[param].icon]} /> }

                  <span style={{ position: 'relative'}}>
                    { categories[param].value }
                  </span>
                </Link>
              </div>
            </li>
          );
        }

        return (
          <li
            key={`${param}-${i}`}
            className={`${s['category__item']} ${isActive(param) ? s['category__item_active'] : ''}`}
            onClick={onNavigationClick}
          >
            <div className={s['category__item_wrapper']}>
              <Link
                  to={{ pathname: removeExtraSlashesFromUrl(`${pathname}/${param}/`) }}
                  className={s['category__item_link']}
              >
                <span style={{ position: 'relative'}}>
                  { categories[param] }
                </span>
              </Link>
            </div>
          </li>
        );
      })}
    </ul>
  );
};
